import campus from './global-campus';
import Permission from './permission/permission.vue';
import ClassSelector from './search-selector/class-selector';
import TeacherSelector from './search-selector/teacher-selector';
import StudentSelector from './search-selector/student-selector';
import CourseSelector from './search-selector/course-selector';
import PriceitemSelector from './search-selector/priceitem-selector';
import CourseCascader from './search-selector/course-cascader/index';
import ClassroomSelector from './search-selector/classroom-selector';
import CommoditySelector from './search-selector/commodity-selector';
import OrderflagSelector from './search-selector/orderflag-selector';
import UniversalCardSelector from './search-selector/universalCard-selector';
import cepingTemplateSelector from './search-selector/cepingTemplate-selector';
import BasicSelector from './basic-selector/index';
import openWallet from './open-wallet/open-wallet.vue';
import yxTips from './yx-tips/yx-tips.vue';
import countDown from './count-down/index';
import PrintPlugin from './print';
import TextEllipsis from './text-ellipsis/text-ellipsis.vue';

export default {
  install(application) {
    application
      .use(ClassSelector)
      .use(TeacherSelector)
      .use(StudentSelector)
      .use(CourseSelector)
      .use(PriceitemSelector)
      .use(CourseCascader)
      .use(ClassroomSelector)
      .use(CommoditySelector)
      .use(BasicSelector)
      .use(countDown)
      .use(campus)
      .use(PrintPlugin)
      .use(OrderflagSelector)
      .use(UniversalCardSelector)
      .use(cepingTemplateSelector)
      .use(TextEllipsis);
  },
};

export { Permission, openWallet, yxTips, TextEllipsis };
